<template>
  <div class="confirmation">
    <!-- <div class="heading-icon" style="background-color: #2a9d8f">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
        <path d="M20 6L9 17l-5-5"></path>
      </svg>
    </div> -->
    <h1 class="title-with-underline">掛號成功</h1>

    <div class="reminder-green" v-html="reminderMessage"></div>

    <div class="appointment-info">
      <div class="info-item" v-for="(item, index) in infoItems" :key="index">
        <span class="info-label">{{ item.label }}</span>
        <span class="info-value" :class="item.color">{{ item.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Confirmation',
  props: {
    clinicName: {
      type: String,
      default: '姜博文診所'
    },
    visitPurpose: {
      type: String,
      default: '體檢 / 健檢'
    },
    examTypeText: {
      type: String,
      default: '成人健檢'
    },
    visitTimeSlot: {
      type: String,
      default: '2025-09-11-afternoon'
    },
    patientName: {
      type: String,
      default: '王小明 (本人)'
    }
  },
  computed: {
    formattedVisitDate() {
      const lastHyphenIndex = this.visitTimeSlot.lastIndexOf('-');
      const datePart = this.visitTimeSlot.substring(0, lastHyphenIndex);
      const timeSlot = this.visitTimeSlot.substring(lastHyphenIndex + 1);
      const date = new Date(datePart);
      if (isNaN(date.getTime())) return '日期格式錯誤';

      const month = date.getMonth() + 1;
      const day = date.getDate();
      const weekday = ['日', '一', '二', '三', '四', '五', '六'][date.getDay()];
      const timeSlotText =
        timeSlot === 'morning' ? '上午診' :
        timeSlot === 'afternoon' ? '下午診' :
        timeSlot === 'evening' ? '晚診' : '診';

      return `${month}/${day} (${weekday}) ${timeSlotText}`;
    },
    infoItems() {
      return [
        { label: '就診醫院', value: this.clinicName },
        { label: '看診日期', value: this.formattedVisitDate, color: 'text-green' },
        { label: '看診人', value: this.patientName },
        { label: '看診身分', value: '一般看診' },
        { label: '看診科別', value: '家醫科', color: 'text-yellow' },
        { label: '就診目的', value: this.visitPurpose },
        { label: '體檢種類', value: this.examTypeText },
        { label: '看診醫師', value: '黃柏維醫師', color: 'text-yellow' },
        { label: '看診號', value: '20 號', color: 'text-green' },
      ];
    },
    reminderMessage() {
      return "1. 感謝您預約XXX，提醒您需於 2025/10/16 (週四) 19:00 前至現場報到。<br>2. 我們將於預約日 3 天前傳送訊息提醒您前來，請再留意訊息。<br>3. 可點選圖文選單之「約診查詢」查詢您的預約訊息。";
    },
  }
}
</script>

<style lang="scss" scoped>
.appointment-info {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;

  @media (min-width: 768px) {
    padding: 24px;
  }
}

.info-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 4px;
  border-bottom: 1px solid #e9ecef;
  padding: 12px 0;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    padding: 16px 0;
  }

  &:last-child {
    border-bottom: none;
  }
}

.info-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;

  @media (min-width: 768px) {
    font-size: 18px;
  }
}

.info-value {
  font-size: 16px;
  color: #333;
  font-weight: 700;

  @media (min-width: 768px) {
    font-size: 18px;
  }
}
</style>
